<template>
  <div id="app">
    <div class="container mx-auto leading-tight">
      <div class="px-4">
        <div class="my-8">
          <div class="flex flex-wrap -mx-4">
            <div class="w-full sm:w-1/3 px-4">
              <h1 class="text-xl mb-2">Vue Packer</h1>
            </div>
            <div class="w-full sm:w-2/3 px-4">
              <p>
                A dependency free Vue component for responsive masonry-style
                cascading grid layouts.
              </p>
            </div>
          </div>
        </div>
        <div class="border-t border-light" />
        <ExampleBasic class="my-8" />
        <div class="border-t border-light" />
        <ExampleDynamic class="my-8" />
        <div class="border-t border-light" />
        <ExampleResponsive class="my-8" />
        <div class="border-t border-light" />
        <ExampleImages class="my-8" />
      </div>
    </div>
  </div>
</template>

<script>
import ExampleBasic from '@/components/ExampleBasic.vue';
import ExampleDynamic from '@/components/ExampleDynamic.vue';
import ExampleImages from '@/components/ExampleImages.vue';
import ExampleResponsive from '@/components/ExampleResponsive.vue';

export default {
  name: 'app',
  components: {
    ExampleBasic,
    ExampleDynamic,
    ExampleImages,
    ExampleResponsive,
  },
};
</script>

<style lang="sass">
@tailwind preflight
@tailwind components
@tailwind utilities

#app
  font-family: -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: #000000

.pin-t-4
  top: 1rem

.hl
  &-tag
    @apply text-blue
  &-string
    @apply text-green
  &-number
    @apply text-purple
  &-keyword
    @apply text-orange
  &-comment
    @apply text-grey
</style>
